import type { BaseComponentConfig, SlotGameStore } from "@gamzix/slot_core";
import { CONST } from "../../../src/const";
import { PaytableWinningSchemes } from "./PaytableWinningSchemes";

class UIComponent extends SlotGame.src.component.UIComponent {

  wrapperSchema;  

  public onGameReady() {
    super.onGameReady();

    this.wrapperSchema = game.tree.findByName("ui.menu.paytable.wrapper_payLines_schema");
    PaytableWinningSchemes.createAndAdd(this.wrapperSchema);
  }


  constructor(config: BaseComponentConfig) {
        /*
    * this is very dirty temporary fix for patriana.
    */
    const params = new URLSearchParams(new URL(window.location.href).search);
    const lang = params.get('lang');
    const provider = params.get('provider');
    const isSocial = lang === 'en_sc';
    const isPatriana = isSocial && provider === 'patriana';

    if (isPatriana) {
      const replaceStrings:[string, string][] = [
        ["how_to_play_descr_3", "Animation, graphics or user interface added to the game are for graphic and visual purposes only. "],
        ["how_to_play_descr_4", "They do not affect the activation of any game features, including bonuses."],
        ["how_to_play_descr_5", ""]
      ];
      const elements = config.config.rules.view.filter(el => el.name === 'ui.menu.rules.p.general_descr');
      elements.forEach(el => {
        for (let i = 0; i < el.texts.length; i++) {
          for(let j = 0; j < replaceStrings.length; j++){
            const [matchStr, replaceStr] = replaceStrings[j];
            if(el.texts[i].endsWith(matchStr)){
              el.texts[i] = replaceStr;
              continue;
            }
          }
        }
      });
    }
    /*
    * end of partiana fix // TODO add proper fix for patriana localizations.
    */
    super(config);

    const store = <SlotGameStore>game.store;

    this.text_checkers = {
      ...super.getTextCheckers(),
      GET_SYMBOL_COUNT_PAYOUT_X: (element) => {
        const { symbol, count } = element.options.data;
        const payout = store.gameRules.getSymbolPayouts(symbol)[count - 1];
        const payInCent = store.gameData.bet * payout;

        return `x${count} - ${store.toFormatMoney(payInCent)}`;
      },

      POSITIONS_NUMBER: () => CONST.COLUMNS * CONST.ROWS,
      NUMBER_REELS: () => CONST.COLUMNS,
      NUMBER_ROWS: () => CONST.ROWS,
      NUMBER_PAY_LINES: () => 20,
      NUMBER_ALL_POSITION_BONUS_SYMBOLS: () => CONST.COLUMNS * CONST.ROWS,

      PLATINUM_J_VALUE: () => 5000,
      MAJOR_J_VALUE: () => 150,
      MINOR_J_VALUE: () => 50,
      MINI_J_VALUE: () => 20,

      PLATINUM_J_VALUE_DYNAMIC: () => store.toFormatMoney(store.gameData.bet * this.store.gameData.bonusGame.JACKPOT.GRAND.multiplier),
      MAJOR_J_VALUE_DYNAMIC: () => store.toFormatMoney(store.gameData.bet * this.store.gameData.bonusGame.JACKPOT.MAJOR.multiplier),
      MINOR_J_VALUE_DYNAMIC: () => store.toFormatMoney(store.gameData.bet * this.store.gameData.bonusGame.JACKPOT.MINOR.multiplier),
      MINI_J_VALUE_DYNAMIC: () => store.toFormatMoney(store.gameData.bet * this.store.gameData.bonusGame.JACKPOT.MINI.multiplier),

      GAME_NAME: () => game.env.gameName
    }
  }

  get store(): SlotGameStore {
    return <SlotGameStore>game.store;
  }
}

//@ts-ignore
Game.src.component.UIComponent = UIComponent;
